import api from "./api";

export default class MemberApi {
  static async getList(data) {
    return await api.get(`member`, data);
  }

  static async getCancelList(data) {
    return await api.get(`retired-member`, data);
  }

  static async getById(id) {
    return await api.get(`member/${id}`);
  }

  static async activation(id, data) {
    return await api.patch(`member/activation/${id}`, data);
  }

  static async delete(data) {
    return await api.del(`member`, data);
  }

  static async deleteCancelMember(data) {
    return await api.del(`retired-member`, data);
  }

  static async editMember(id, data) {
    return await api.patch(`member/${id}`, data);
  }

  static async getLectureList(data) {
    return await api.get(`member-lecture`, data);
  }
}
